import { createSelector } from 'reselect';

import { TState } from '~/src/store';

import type { IFullBuyTariff } from '../tariffTransformer';

// Выбирает тариф по salePackageId или alias
export const selectCurrentTariff = createSelector(
    [
        (state: TState) => state.fullBuy,
    ],
    ({ tariffs, selectedTariff }): IFullBuyTariff | null => {
        if (!selectedTariff) {
            return null;
        }

        if ('salePackageId' in selectedTariff) {
            const { salePackageId } = selectedTariff;
            const currentTariff = tariffs.find(tariff => tariff.sale_package_id === salePackageId);
            return currentTariff || null;
        } else {
            const { tariffNameAlias, monoTariff } = selectedTariff;
            const currentTariff = tariffs.filter(el => el.isMono === monoTariff).find(tariff => tariff.alias === tariffNameAlias);
            return currentTariff || null;
        }
    },
);
